/**
 * Resolve a post-login redirect target to a safe, same-origin destination.
 *
 * The raw value comes from the user-controlled `redirect-to` query param, so it
 * is parsed against the current origin and only returned when it stays on the
 * same origin AND uses an http(s) protocol. Anything cross-origin, a
 * `javascript:`/`data:` scheme, or a malformed value falls back to '/', which
 * prevents open-redirect phishing.
 */
export const getSafeRedirectUrl = (
  rawRedirect: string,
  origin: string = window.location.origin,
): string => {
  try {
    const safeRedirect = new URL(rawRedirect, origin)

    return safeRedirect.origin === origin &&
      ['http:', 'https:'].includes(safeRedirect.protocol)
      ? safeRedirect.href
      : '/'
  } catch {
    return '/'
  }
}
